import * as ActionConfigurationManager from './config.actions';

export const submitAVS = ActionConfigurationManager.SUBMIT_FOR_AVS;
export const avsSubmitted = ActionConfigurationManager.AVS_SUBMITTED;
export const rehydrateAVS = ActionConfigurationManager.REHYDRATE_AVS;